import React, { useState } from "react";

import Dialog, { DialogTitle, DialogActions } from "components/common/Dialog";
import Button from "components/common/Button";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { Snackbar, SnackbarContent } from "@mui/material";

import { reactivateEmployee } from "services/Admin/Dashboard";

import "./MarkInActiveWithReason.scss";

export default function MarkAsActive({ selectedId, open, setOpen, employeeFullName, getEmployeeListHandler }) {
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      await reactivateEmployee(selectedId);
      setLoading(false);
      setOpen(false);
      setIsSuccess(true);
      setSnackbarOpen(true);
      getEmployeeListHandler();
    } catch (error) {
      setLoading(false);
      setIsSuccess(false);
      setSnackbarOpen(true);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="mark-active-title"
        size="sm"
        fullWidth={false}
        title={
          <>
            <div className="icon-container" style={{ backgroundColor: "#f0fff4" }}>
              <CheckCircleOutlineIcon className="inactive-employee-amber-icon" style={{ color: "#2e7d32" }} />
            </div>
            <DialogTitle title="Mark as Active" />
          </>
        }
        content={
          <div className="employee-already-inactive-wrapper">
            <p className="mark-inactive-message">
              Are you sure you want to mark <span>{employeeFullName}</span> as <span>active</span>?
            </p>
          </div>
        }
        actions={
          <DialogActions
            action1={<Button variant="text" label="Cancel" size="large" onClick={handleClose} />}
            action2={<Button label="Save" size="large" onClick={handleSave} isDisabled={loading} isLoading={loading} />}
          />
        }
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <SnackbarContent
          message={
            <span className="inactive-employee-message">
              {isSuccess ? <DoneIcon className="mark-inactive-done-icon" /> : null}
              {isSuccess ? (
                <p className="custom-snackbar-message">
                  <span>{employeeFullName}</span> has been marked as <span>Active</span>
                </p>
              ) : (
                <p className="custom-snackbar-message">Failed to mark employee as active. Please try again.</p>
              )}
            </span>
          }
          action={<CloseIcon onClick={handleSnackbarClose} />}
          className="custom-snackbar-content"
        />
      </Snackbar>
    </>
  );
}
